Mmg.addShortcode(

  /**
   *
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'job_page_search',
  '.sc-job-page-search',

  /**
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

  // Widget Declarations
  const $this = $(el);
  const disciplineSelector = '[name=discipline]';
  const specialtySelector = '[name=specialty]';
  const locationSelector = '[name=location]';
  const $discipline = $this.find(disciplineSelector);
  const $specialty = $this.find(specialtySelector);
  const $location = $this.find(locationSelector);
  const $submit = $this.find('button');
  const form = new Mmg.Form($this);
  let locationsMap = model.locationsMap;


  /**
   * Initialize the widget
   */
  (function init(){
    $this.on('click', 'button', handleSubmit);
    addEventHandlers();
  })();


  /**
   * Handle events in the UI
   */
  function addEventHandlers(){
    $this.on('change', disciplineSelector, handleDisciplineChange);
    $this.on('change', specialtySelector, handleSpecialtyChange);
    $this.on('change', locationSelector, handleLocationChange);
  }


  /**
   * Reset a select element
   * @param jQuery $element 
   */
  function reset($element) {
    $element.prop('disabled', true);
    $element.find('option[value!=0]').remove();
    $submit.prop('disabled', true);
  }


  /**
   * Load specialty data when discipline is changed
   * @param {event} event 
   */
  function handleDisciplineChange(event) {
    reset($specialty);
    reset($location);
    $.get(model.specialtyApiUrl, {
      discipline: $(event.target).val(),
    }).done(renderSpecialtySelect);
  }


  /**
   * Load location page data when specialty is changed
   * @param {event} event 
   */
  function handleSpecialtyChange(event) {
    reset($location);
    $.get(model.pagesApiUrl, {
      discipline: $discipline.val(),
      specialty: $(event.target).val(),
    }).done(renderLocationSelect);
  }


  /**
   * Enable/Disable submit when location is selected 
   * @param {event} event 
   */
  function handleLocationChange(event) { 
    $submit.prop('disabled', $location.val() == 0);
  }


  /**
   * Render the Specialty select element
   * @param {object} data 
   */
  function renderSpecialtySelect(data) {
    $specialty.html(
      form.renderSelect($specialty, {specialty: data.specialties})
    ).prop('disabled', false);
  }


  /**
   * Render the location select element and create the lookup map for page URLs.
   * @param {object} data 
   */
  function renderLocationSelect(data) {
    let options = [];
    let locations = data.pages;
    locationsMap = {};

    for(let i = 0; i < locations.length; i++){
      let location = locations[i];
      options.push(location.location);
      locationsMap[location.location] = location.url;
    }

    $location.html(
      form.renderSelect($location, {location: options})
    ).prop('disabled', false);
  }


  /**
   * Navigate to the chosen page on submit.
   * 
   * @param {event} event 
   */
  function handleSubmit(event) {
    event.preventDefault();
    window.location = locationsMap[$location.val()];
  }

});
